<template>
  <div>
    <!-- Row top buttons -->
    <div class="row q-mb-lg">
      <div class="col-4" style="justify-content: flex-start">
        <q-btn
          class="capitalize ctrl-button"
          color="grey-5"
          :label="`${$store.state.stringsStore.strings.action.toOverview}`"
          @click="$router.push('/defaultcart')"
          icon="keyboard_backspace"
        />
      </div>
      <div class="col-8">
        <q-btn  style="float: right"
          class="capitalize ctrl-button right q-ml-md"
          :color="'ctrl-turquoise'"
          :disable="false"
          :label="`${$store.state.stringsStore.strings.action.save}`"
          @click="saveChanges()"
          icon-right="save"
        />
        <q-btn v-if="data.id"
          class="q-ml-md capitalize ctrl-button right"
          icon-right="delete"
          color="negative capitalize"
          :label="$store.state.stringsStore.strings.action.delete"
          align="right"
          @click="deleteDefaultCart()"
        />
        <q-btn
          v-if="data.code"
          class="q-ml-md capitalize ctrl-button right"
          icon-right="arrow_forward"
          color="info"
          :label="$store.state.stringsStore.language === 'en' ? 'Go to cart' : 'Naar winkelwagen'"
          @click="goToCart()"
        />
        <q-btn
          class="capitalize ctrl-button right"
          icon-right="arrow_forward"
          color="info"
          :label="$store.state.stringsStore.language === 'en' ? 'Show usage' : 'Toon gebruik'"
          @click="$router.push(`/defaultcart/${$route.params.id}/usage`)"
        />
      </div>
    </div>

      <!-- Left -->
      <div class="col-md-6 col-sm-12 col-xs-12">
        <div class="row q-mb-sm">
          <div class="full-width">
            <p class="card-title">Details</p>

            <div class="card-block">
              <div class="row  q-mb-md">

                <div class="col-md-4 col-sm-12">
                  <q-input
                    class="q-mr-md"
                    color="primary"
                    v-model="data.name"
                    :float-label="getString('name')"/>
                </div>
                <div class="col-md-4 col-sm-6">
                  <!-- Start date -->
                  <q-datetime
                    :max="data.date.end"
                    class="q-mr-md"
                    :float-label="startDate"
                    v-model="data.date.start" />
                </div>
                <div class="col-md-4 col-sm-6">
                  <!-- End date -->
                  <q-datetime
                    :min="data.date.start"
                    :float-label="endDate"
                    v-model="data.date.end"
                    clearable />
                </div>

            </div>

            <div class="row q-mb-md">
              <div class="col-md-3">
                <q-search class="q-mr-md" type="text" v-model="data.account.name"
                  :disable="disable"
                  :float-label="'Account'">
                  <q-autocomplete :max-results="25" :min-characters="2" @search="searchAccount" @selected="selectAccount"/>
                </q-search>
              </div>
              <div class="col-md-3">
                  <q-input
                    class="q-mr-md"
                    color="primary"
                    v-model="data.minimal_order_amount"
                    float-label="Minimum order amount"/>
              </div>

              <div class="col-md-2">
                <q-field>
                  <q-toggle
                    class="q-mt-lg"
                    :disable="readOnly"
                    v-model="data.has_promotions"
                    color="secondary">
                    <span style="margin-left: 1em;">
                      {{ getString('module.defaultcart.field.hasPromotions') }}
                    </span>
                  </q-toggle>
                </q-field>
              </div>
              <div class="col-md-2">
                <q-field>
                  <q-toggle
                    class="q-mt-lg"
                    :disable="readOnly"
                    v-model="data.mix_items"
                    color="secondary">
                    <span style="margin-left: 1em;">
                      {{ getString('module.defaultcart.field.mixItems') }}
                      <q-icon name="help">
                        <q-tooltip :delay="200">
                          <div style="max-width: 400px">
                          {{ getString('module.defaultcart.tooltip.mixItems') }}
                          </div>
                        </q-tooltip>
                      </q-icon>
                    </span>
                  </q-toggle>
                </q-field>
              </div>
              <div class="col-md-2 col-sm-2">
                <q-field>
                  <q-toggle
                    class="q-mt-lg"
                    :disable="readOnly"
                    v-model="data.is_single_use"
                    color="secondary">
                    <span style="margin-left: 1em;">
                      {{ getString('module.defaultcart.field.singleUse') }}
                    </span>
                  </q-toggle>
                </q-field>
              </div>
            </div>

            <div class="row q-mb-md">
              <div class="col-md-12 col-sm-12">
                  <q-input
                    type="textarea"
                    color="primary"
                    v-model="data.description"
                    :float-label="getString('description')"/>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Right -->
      <div class="col-md-12 col-sm-12 col-xs-12 q-mt-md">
        <div class="row q-mb-sm">
          <div class="full-width">
            <p class="card-title">
              {{ 'Items' }}
            </p>

            <q-btn class="ctrl-button capitalize q-mb-md" color="primary"
              @click="addNewItem" :label="getString('action.add')"/>

            <div class="card-block q-mb-sm" :class="{ 'item-deleted' : item.deleted }" v-for="(item, r) in combinedItems" :key="`item-${r}`">

              <div class="row">

                <!-- Item -->
                <div class="col-md-6 col-sm-12">
                  <q-search type="text" v-model="item.item.code"
                    placeholder="Item"
                    class="q-mr-md"
                    :disable="disable"
                    float-label="Item">
                    <q-autocomplete :max-results="25" :min-characters="2" @search="search" @selected="selected(...arguments, item)" />
                  </q-search>
                </div>

                <!-- Quantity -->
                <div class="col-md-3 col-sm-6">
                  <q-input
                    class="q-mr-md"
                    color="primary"
                    v-model="item.quantity"
                    :float-label="getString('module.promotion.type.itemQuantity')" />
                </div>

                <!-- Price -->
                <div class="col-md-3 col-sm-6">
                  <q-input
                    class="q-mr-md"
                    color="primary"
                    v-model="item.price"
                    :float-label="getString('module.course.details.price')" />
                </div>
              </div>

              <q-btn v-if="!item.deleted" class="ctrl-button capitalize q-mb-md q-mt-md" color="negative"
              @click="removeItem(r)" :label="getString('action.delete')"/>

              <q-btn v-if="item.deleted" class="ctrl-button capitalize q-mb-md q-mt-md" color="positive"
              @click="restoreItem(r)" label="restore"/>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import qs from 'qs';
import moment from 'moment';

// Mixins
import getString from '@/helpers/GetStrings';
import errorHandler from '@/mixins/detailViews/errorHandler';

export default {
  mixins: {
    errorHandler,
  },
  data() {
    return {
      // Name of the module defined in user rights. eg. blog for blog.edit, blog.add etc..
      permission: 'defaultcart',
      // Where data is fetched from
      endpoint: 'defaultcart',
      // The object key from the response object
      responseData: {
        single: 'defaultcart',
        multiple: 'defaultcarts',
      },

      readOnly: false,
      disable: false,

      // Used for navigation on the front-end (matching the router)
      module: 'defaultcart',

      data: {
        name: '',
        description: '',
        date: {
          start: Date.now(),
          end: null,
        },
        account: {
          id: '',
          name: '',
        },
        items: [],
        minimal_order_amount: 0,
        has_promotions: false,
        is_single_use: false,
        mix_items: false,
      },

      newItems: [],
      items: [],

      // When an existing item is removed, it is added to this array for a delete on save.
      itemsRemoved: [],

    };
  },

  methods: {
    getString,

    goToCart() {
      window.open(this.codeUrl, '_blank').focus();
    },

    async search(terms, done) {
      try {
        // Request items based on terms given
        const results = await this.axios.get(`item?autocomplete=${terms.toLowerCase()}`);

        // Map only the item names/labels... to the suggested array
        const suggested = results.data.items.map(item => ({ label: item.code, id: item.id, gross_price: item.gross_price }));

        // Suggested items found, return suggestions.
        if (suggested.length) {
          done(suggested);
        }

      // Since an error is thrown when no items are found in autocomplete -> promt new suggestion here.
      } catch (error) {
        done([]);
      }
    },

    async searchAccount(terms, done) {
      try {
        // Request items based on terms given
        const results = await this.axios.get(`account?autocomplete=${terms.toLowerCase()}`);

        // Map only the item names/labels... to the suggested array
        const suggested = results.data.accounts.map(item => ({ label: item.name, id: item.id }));

        done(suggested);
      } catch (error) {
        done([]);
      }
    },

    selectAccount(account) {
      this.data.account = {
        name: account.label,
        id: account.id,
      };
    },

    selected(item, keyboard, selected) {
      // Prevent adding on keyboard arrow down
      if (keyboard) return;

      selected.item.id = item.id;
      selected.item.code = item.label;
      selected.item.gross_price = item.gross_price;

      this.inputField = '';
    },

    addNewItem() {
      this.newItems.unshift({
        item: {
          id: null,
          code: null,
        },
        quantity: null,
        price: null,
      });
    },

    fetchDefaultCart() {
      this.axios.get(`defaultcart/${this.$route.params.id}`).then(async (res) => {
        if (!res.data.defaultcart.account) {
          res.data.defaultcart.account = {
            id: null,
            name: null,
          };
        }
        this.data = res.data.defaultcart;
      });
    },

    deleteDefaultCart() {
      this.axios.delete(`defaultcart/${this.$route.params.id}`).then(() => {
        this.$router.push('/defaultcart');
      });
    },

    updateAccounts(newVal) {
      this.data.accounts = newVal;
    },

    removeItem(index) {
      const item = this.combinedItems[index];
      // Move only existing items to itemsRemoved array.
      if (item.id) {
        this.itemsRemoved.push(item);
        // Set deleted to true in the filtered array.
        this.$set(this.data.items[index], 'deleted', true);
      } else {
        this.newItems.splice(index, 1);
      }
    },

    restoreItem(index) {
      const item = this.data.items[index];
      // Remove the item from the itemsRemoved array.
      this.itemsRemoved = this.itemsRemoved.filter(x => x.id !== item.id);

      this.$set(this.data.items[index], 'deleted', false);
    },

    /**
     * Saving a promotion requires saving the promotion itself as well as each item within the promotion.
     */
    saveChanges() {
      if (this.$route.params.id) {
        this.saveExistingDefaultCart();
      } else {
        this.saveNewDefaultCart();
      }
    },

    saveExistingDefaultCart() {
      const data = {
        name: this.data.name,
        description: this.data.description,
        minimal_order_amount: this.data.minimal_order_amount,
        account: this.data.account.id,
        has_promotions: this.data.has_promotions ? 1 : 0,
        mix_items: this.data.mix_items ? 1 : 0,
        single_use: this.data.is_single_use ? 1 : 0,
        date_start: moment(this.data.date.start).format('YYYY-MM-DD'),
      };

      if (this.data.date.end) {
        data.date_end = moment(this.data.date.end).format('YYYY-MM-DD');
      }

      this.axios.put(`defaultcart/${this.$route.params.id}`, qs.stringify(data, { arrayFormat: 'brackets', indices: false })).then(async () => {
        // Save all items.
        await Promise.all(this.combinedItems.map((item) => {
          // Save all existing items.
          if (item.id) {
            if (!item.deleted) {
              return this.saveExistingItem(item);
            }
            return true;
          }
          // Save all new items.
          return this.saveNewItem(item);
        })).then(() => {
          this.newItems = [];
        }).catch((err) => {
          // Handle the error (handleError mixin)
          this.handleError(err);
        });

        // Apply deletes
        await Promise.all(this.itemsRemoved.map(item => this.axios.delete(`defaultcart/${this.$route.params.id}/items/${item.id}`)));
        this.$q.notify({
          message: getString('module.defaultcart.edit.save.success'),
          type: 'positive',
          timeout: 1200,
          position: 'top-right',
        });
        this.fetchDefaultCart();
      });
    },

    saveNewDefaultCart() {
      const data = {
        name: this.data.name,
        description: this.data.description,
        account: this.data.account.id,
        minimal_order_amount: this.data.minimal_order_amount,
        has_promotions: this.data.has_promotions ? 1 : 0,
        mix_items: this.data.mix_items ? 1 : 0,
        single_use: this.data.is_single_use ? 1 : 0,
        date_start: moment(this.data.date.start).format('YYYY-MM-DD'),
        date_end: this.data.date.end ? moment(this.data.date.end).format('YYYY-MM-DD') : null,
      };

      let location;
      let newId;

      this.axios.post('defaultcart', qs.stringify(data, { arrayFormat: 'brackets', indices: false })).then((response) => {
        // Redirect to detail page of the newly created item
        if (response.headers && response.headers.location) {
          location = response.headers.location.replace('/api', '');
          newId = response.headers.location.split('/').pop();
        }
      }).then(async () => {
        // id availible, post all items.
        await Promise.all(this.combinedItems.map(item => this.saveNewItem(item, newId))).then(() => {
          this.newItems = [];
        }).catch((err) => {
          // Handle the error (handleError mixin)
          this.handleError(err);
        }).finally(() => {
          this.$router.push(location);
          this.$nextTick(() => {
            this.fetchDefaultCart();
          });
        });

        // Successfully saved all new items.
        this.$q.notify({
          message: getString('module.defaultcart.edit.save.success'),
          type: 'positive',
          timeout: 1200,
          position: 'top-right',
        });
      }).catch((err) => {
        // Handle the error (handleError mixin)
        this.handleError(err);
      });
    },

    saveNewItem(item, itemId = null) {
      const itemData = {
        item: item.item.id,
        price: item.price,
        quantity: item.quantity,
      };

      return this.axios.post(`defaultcart/${itemId || this.$route.params.id}/items`, qs.stringify(itemData, { plainObjects: true }));
    },

    saveExistingItem(item) {
      const itemData = {
        item: item.item.id,
        price: item.price,
        quantity: item.quantity,
      };

      return this.axios.put(`defaultcart/${this.$route.params.id}/items/${item.id}`, qs.stringify(itemData, { plainObjects: true }));
    },
  },

  computed: {
    codeUrl() {
      return `${process.env.VUE_APP_SITE}winkelwagen/${this.data.code}`;
    },
    combinedItems() {
      return [...this.newItems, ...this.data.items];
    },

    startDate() {
      return this.$store.state.stringsStore.language === 'nl' ? 'Startdatum' : 'Start date';
    },

    endDate() {
      return this.$store.state.stringsStore.language === 'nl' ? 'Einddatum' : 'End date';
    },
  },

  mounted() {
    if (this.$route.params.id) {
      this.fetchDefaultCart();
    }
  },
};
</script>

<style lang="stylus">
.card-block.item-deleted
    background rgba(255, 255, 255, 0.5)
</style>
